<!-- 
@author Zou Tiancong
@version 0.0.1
@createDate 2021年4月8日
@updateDate 2022年11月10日
 -->
<template>
	<div class="z-table-div">
		<el-table :data="data"
			:height="option.table.height"
			:max-height="option.table.maxHeight"
			:stripe="option.table.stripe"
			:border="option.table.border"
			:size="option.table.size ||'mini'"
			:fit="option.table.fit"
			:show-header="option.table.showHeader"
			:highlight-current-row="option.table.highlightCurrentRow"
			:current-row-key="option.table.currentRowKey"
			:row-class-name="option.table.rowClassName || rowClassName"
			:row-style="option.table.rowStyle"
			:cell-class-name="option.table.cellClassName"
			:cell-style="option.table.cellStyle"
			:header-row-class-name="option.table.headerRowClassName"
			:header-row-style="option.table.headerRowStyle"
			:header-cell-class-name="option.table.headerCellClassName"
			:header-cell-style="option.table.headerCellStyle || headerCellStyle"
			:row-key="option.table.rowKey"
			:empty-text="option.table.emptyText"
			:default-expand-all="option.table.defaultExpandAll"
			:expand-row-keys="option.table.expandRowKeys"
			:default-sort="option.table.defaultSort"
			:tooltip-effect="option.table.tooltipEffect"
			:show-summary="option.table.showSummary"
			:sum-text="option.table.sumText"
			:summary-method="option.table.summaryMethod"
			:span-method="option.table.spanMethod"
			:select-on-indeterminate="option.table.selectOnIndeterminate"
			:indent="option.table.indent"
			:lazy="option.table.lazy"
			:load="option.table.load"
			:tree-props="option.table.treeProps"
			v-loading="option.table.loading"
			@row-click="rowClick"
			@selection-change="selectionChange">
			<!-- 选择框是否开启，selectable控制是否单行禁止选中 -->
			<el-table-column v-if="option.column.selection"
				type="selection"
				:selectable="option.column.selectable"
				width="50px" />
			<!-- 序号 -->
			<el-table-column v-if="option.column.showIndex"
				:label="option.column.indexText || '序号'"
				type="index"
				align="center"
				width="50px" />
			<!-- 普通列 -->
			<el-table-column v-if="!column.noShow"
				v-for="(column,columIndex) in option.column.columnList"
				:key="columIndex"
				:index="columIndex"
				:column-key="column.columnKey"
				:label="column.label"
				:prop="column.prop"
				:width="column.width"
				:min-width="column.minWidth"
				:fixed="column.fixed"
				:render-header="column.renderHeader"
				:sortable="column.sortable"
				:sort-method="column.sortMethod"
				:sort-by="column.sortBy"
				:sort-orders="column.sortOrders"
				:resizable="column.resizable"
				:formatter="column.formatter"
				:show-overflow-tooltip="column.showOverflowTooltip || true"
				:align="column.align || 'center'"
				:header-align="column.headerAlign"
				:class-name="column.className"
				:label-class-name="column.labelClassName"
				:reserve-selection="column.reserveSelection"
				:filters="column.filters"
				:filter-placement="column.filterPlacement"
				:filter-multiple="column.filterMultiple"
				:filter-method="column.filterMethod"
				:filtered-value="column.filteredValue">
				<template slot-scope="{row,$index}">
					<span>
						<!-- 默认展示 -->
						<span v-if="column.type=='text' && column.editRow != $index"
							v-show="!column.noShow">{{ column.dict ? dictGet(row[column.prop],column.dict,column.props) : row[column.prop]}}</span>
						<!-- 可编辑input，仅在text默认展示类型才可编辑-->
						<el-input v-focus
							v-if="column.editRow == $index"
							v-model="row[column.prop]"
							@blur="editInputBlur(row,$index,column.prop,columIndex)" />
						<!-- 选择框 -->
						<el-select v-if="column.type == 'select'"
							v-model="row[column.prop]"
							:multiple="column.multiple"
							:disabled="column.disabled"
							:value-key="column.valueKey"
							:clearable="column.clearable"
							:collapse-tags="column.collapseTags"
							:multiple-limit="column.multipleLimit"
							:placeholder="column.placeholder ||(column.showPlaceholder?'请选择'+column.label :'')"
							:filterable="column.filterable"
							:remote="column.remote"
							:remote-method="(query)=>remoteMethod(query,$index,column.prop)"
							:loading="searchSelectLoading"
							@change="selectChange($event,column,row,$index)">
							<el-option v-for="(options, sIndex) in column.options"
								:key="sIndex"
								:label="column.props ? options[column.props.label] : options.label"
								:value="column.props ? options[column.props.value] : options.value" />
						</el-select>
						<!-- 对象展示 -->
						<span v-if="column.type=='object'"
							v-show="!column.noShow">{{row[column.prop][column.objKey]}}</span>
						<!-- 自定义内容 -->
						<span v-if="column.type=='ownDefined'"
							v-show="!column.noShow">{{column.ownDefinedReturn(row,$index)}}</span>
						<!-- switch开关 -->
						<el-switch v-if="column.type=='switch'"
							v-show="!column.noShow"
							v-model="row[column.prop]"
							:disabled="column.disabled"
							:active-icon-class="column.activeIconClass"
							:inactive-icon-class="column.inactiveIconClass"
							:active-text="row[column.prop] ? column.activeText : ''"
							:inactive-text="!row[column.prop] ? column.inactiveText : ''"
							:active-value="column.activeValue"
							:inactive-value="column.inactiveValue"
							:active-color="column.activeColor"
							:inactive-color="column.inactiveColor"
							:validate-event="column.validateEvent"
							@change="switchChange(row,$index,column.prop)" />

						<!-- 图片展示 -->
						<el-image v-if="column.type=='image' && row[column.prop] && row[column.prop].length > 0"
							:src="row[column.prop] instanceof Array ? row[column.prop][0] : row[column.prop]"
							:preview-src-list="row[column.prop] instanceof Array ? row[column.prop] : [row[column.prop]]"></el-image>
						<!-- tab标签 -->
						<el-tag v-if="column.type=='tagDict'"
							v-show="!column.noShow"
							:type="column.tagType(row,$index)">
							{{dictGet(row[column.prop],column.dict,column.props)}}
						</el-tag>
						<!-- 操作按钮 -->
						<div v-if="column.type=='operation'"
							v-show="!column.noShow"
							class="z-operation"
							:style="{width:(column.width - 20) +'px'}">
							<el-button v-for="(operation, index) in column.operation"
								:key="index"
								v-show="operation.isShow(row,$index)"
								:icon="operation.icon"
								:type="operation.type"
								@click="operation.buttonClick(row,$index)"
								:style="{color:operation.color}"
								size="small">
								{{operation.label}}
							</el-button>
						</div>
						<slot v-if="column.type=='slot'"
							:name="column.prop"
							:data="{row,$index}" />
					</span>
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<div class="page_div"
			v-if="option.page"
			:style="{textAlign: option.page.position || 'center'}">
			<el-pagination :small="option.page.small"
				v-if="option.page"
				:background="option.page.background"
				:page-size="option.page.pageData.pageSize"
				:total="option.page.total"
				:page-count="option.page.pageCount"
				:pager-count="option.page.pagerCount"
				:current-page="option.page.pageData.currentPage"
				:layout="option.page.layout || layout"
				:page-sizes="option.page.pageSizes || [10, 15, 20, 30,50]"
				:popper-class="option.page.popperClass"
				:prev-text="option.page.prevText"
				:next-text="option.page.nextText"
				:disabled="option.page.disabled"
				:key="option.page.pageData.pageSize"
				:hide-on-single-page="option.page.hideOnSinglePage"
				@size-change="sizeChange"
				@current-change="currentChange"
				@prev-click="prevClick"
				@next-click="nextClick">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'z-el-table',
		directives: {
			// 自定义指令,用于可编辑input自动获取焦点
			focus: {
				inserted: function(e) {
					e.querySelector('input').focus()
				}
			}
		},
		props: {
			data: {
				type: Array,
				required: true,
			},
			option: {
				type: Object,
				default: () => {
					return {};
				},
			},
			// option.table是table所有配置，集成了element自身所有配置，以及新增了一些个性化配置

			// option.column列配置选项，继承了element自身的所有配置，将选择框操作提出来在option.column属性上，其他依然保留各自列
			//option.column.type(如果为""空，就不会加载多选框，或者index编号),lazy(是否支持懒加载)
			//columnList.columType(列类型,可选text(默认为普通文字模式),input(input可编辑框),switch(switch开关),image(图片),operation(操作按钮))
			//prop(参数),label(列名),width(宽度),align(对齐方式),sortable(是否支持排序)
			//如果为操作列,则需要填写需要的操作按钮,类型为Object。type(按钮样式,参考el—botton类型),label(按钮文字)icon(参考el-icon),color(字体颜色),buttonClick为点击后调用的方法名称
		},
		data() {
			return {
				searchSelectLoading: false,
				headerCellStyle: {
					background: '#f5f7fa'
				},
				layout: "total, sizes, prev, pager, next, jumper",
			}
		},
		methods: {
			dictGet(val, dict, props) {
				if (String(val) != '' && dict && dict.length > 0) {
					let item = dict.find(item => {
						return props ? item[props.value] == val : item.value == val
					})
					if (item) {
						return props ? item[props.label] : item.label
					}
				}
			},
			// 设置默认行样式
			rowClassName({
				row,
				rowIndex
			}) {
				row.rowIndex = rowIndex;
				// if ((rowIndex + 3) % 3 == 0) {
				// 	return 'success-row'
				// } else if ((rowIndex + 3) % 3 == 1) {
				// 	return 'warning-primary'
				// } else if ((rowIndex + 3) % 3 == 2) {
				// 	return 'warning-row'
				// }
			},
			// switchChange调用
			switchChange(row, $index, prop) {
				this.$emit('switchChange', row, $index, prop);
			},
			// 点击行
			rowClick(row, column, event) {
				this.$emit('rowClick', row, column, event);
			},
			// 选中回调
			selectionChange(selection) {
				this.$emit('selectionChange', selection);
			},
			// 可编辑input失去焦点
			editInputBlur(row, $index, prop, columIndex) {
				this.$emit('editInputBlur', row, $index, prop, columIndex);
			},
			// 条数变化,params每页条数
			sizeChange(event) {
				this.$emit('sizeChange', event);
			},
			// 页码变化,params当前页
			currentChange(event) {
				this.$emit('currentChange', event);
			},
			// 用户点击上一页按钮改变当前页后触发,params当前页
			prevClick(event) {
				this.$emit('prevClick', event);
			},
			// 用户点击下一页按钮改变当前页后触发	,params当前页
			nextClick(event) {
				this.$emit('nextClick', event);
			},
			// 搜索类型select搜索
			remoteMethod(query, index, prop) {
				if (query) {
					this.searchSelectLoading = true;
					this.$emit('querySelectValue', query, index, prop);
					setTimeout(() => {
						this.formColumn[index].options = this.searchSelectOptionsCb;
						this.searchSelectLoading = false;
					}, 500)
				} else {
					this.searchSelectOptios = [];
				}
			},
			//select变化调用
			selectChange($event, column, row, $index) {
				this.$emit('selectChange', $event, column, row, $index);
			},

		}
	}
</script>
<style lang="scss"
	scoped>
	.z-table-div {
		border: 1px #EBEEF5 solid;

		// 分页div
		.page_div {
			padding: 15px;
		}

		// table按钮间距
		.el-button {
			margin: 0 6px;
		}

		.z-operation {
			display: flex;
		}

		// 斑马纹颜色
		::v-deep .el-table .warning-primary {
			background: #ecf5ff;
		}

		// 斑马纹颜色
		::v-deep .el-table .warning-row {
			background: #fdf6ec;
		}

		// 斑马纹颜色
		::v-deep .el-table .success-row {
			background: #f0f9eb;
		}

		// table图片高度
		::v-deep .el-image__inner {
			height: 50px;
		}

		// switch左边文字颜色
		::v-deep .el-switch__label--left {
			color: #606266;
		}
	}
</style>
